import * as React from 'react';

import { translate } from '~l10n/client';
import { useAtom, useAtomValue } from 'jotai';
import { atom } from 'jotai/index';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { Dialog } from '~shared/components/Dialog';
import { useGenerateShareUrl } from '~shared/components/QrCode';
import { ShareRoomDialogConfirm } from '~teacher/components/rooms/ShareRoomDialog/ShareRoomDialogConfirm';
import { ShareRoomDialogContent } from '~teacher/components/rooms/ShareRoomDialog/ShareRoomDialogContent';
import {
  dispatchCloseShareRoomDialog,
  useShareRoomDialogDispatch,
  useShareRoomModalState,
} from '~teacher/components/rooms/ShareRoomDialog/ShareRoomDialogProvider';

// Dialog will transform into a confirm dialog if this is shown
export const showConfirmAtom = atom(false);

export function ShareRoomDialog() {
  const { isOpen, roomId } = useShareRoomModalState();
  const dispatch = useShareRoomDialogDispatch();
  const closeShareRoomModal = () => {
    new FeatureUseEventAdapter({
      feature: 'share_room_dialog',
      action: 'close',
    }).sendAnalytics();

    dispatchCloseShareRoomDialog(dispatch)();
  };

  const showConfirm = useAtomValue(showConfirmAtom);

  return (
    <Dialog
      closeLabel={translate('Close')}
      position="center"
      open={isOpen}
      id="share-room-modal"
      onClose={closeShareRoomModal}
      padding={showConfirm ? 'confirmation' : 'default'}
      title={showConfirm ? '' : translate('Share Room')}
    >
      <ShareRoomDialogInner roomId={roomId} />
    </Dialog>
  );
}

function ShareRoomDialogInner({ roomId }: { roomId: number }) {
  useGenerateShareUrl(roomId);

  const [showConfirm, setShowConfirm] = useAtom(showConfirmAtom);
  React.useEffect(() => {
    setShowConfirm(false);
  }, [setShowConfirm]);

  if (showConfirm) {
    return <ShareRoomDialogConfirm roomId={roomId} />;
  } else {
    return <ShareRoomDialogContent roomId={roomId} />;
  }
}
